function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { Filters } from '@domain-group/fe-allhomes-search-api';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { withAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import buildPriceRangeProps, { getPriceRangeTitle } from '../utils/build-price-range-props';
import buildPropertyTypeProps, { getPropertyTypeTitle } from '../utils/build-property-type-props';
import buildPropertyFeaturesProps, { getPropertyFeaturesTitle } from '../utils/build-property-features-props';
import buildMoreOptionsProps, { getMoreOptionsTitle } from '../utils/build-more-options-props';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MORE_OPTIONS_FILTER_PROPERTIES = ['availability', 'listedPropertyTypes', 'propertyStatus', 'saleMethods', 'onlyWithPrice', 'blockSize', 'floorArea', 'listingFeatures', 'keywords'];
var filterStateHandler = (FilterComponent, options) => {
  class FilterWithState extends React.Component {
    constructor(props) {
      var _this;
      super(props);
      _this = this;
      _defineProperty(this, "onClearFilter", function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$submit = _ref.submit,
          submit = _ref$submit === void 0 ? true : _ref$submit;
        _this.resetFilters().then(filters => {
          if (submit) {
            _this.props.onSubmitFilter(filters);
          }
        });
      });
      _defineProperty(this, "onClearMoreOptions", () => {
        var preservedFilterOptions = this.props.filters.getValues();
        MORE_OPTIONS_FILTER_PROPERTIES.forEach(name => {
          delete preservedFilterOptions[name];
        });
        var filters = new Filters(this.props.listingType, preservedFilterOptions);
        this.setState({
          filters
        });
      });
      _defineProperty(this, "onSubmitFilter", () => {
        this.props.onSubmitFilter(this.state.filters);
      });
      _defineProperty(this, "onCancel", () => {
        this.setState({
          filters: new Filters(this.props.listingType, this.props.filters)
        });
        this.props.onCancel();
      });
      _defineProperty(this, "hasFilterChanged", () => this.state.filters && !isEqual(this.state.filters.getValues(), new Filters(this.props.listingType, {
        localities: this.props.filters.localities
      }).getValues()));
      /**
       * Updates only the provided filter values
       */
      _defineProperty(this, "alterFilters", newValues => {
        var filters = this.state.filters.cloneWith(newValues);
        return new Promise(resolve => {
          this.setState({
            filters
          }, () => resolve(filters));
        });
      });
      _defineProperty(this, "alterNamedFilter", name => value => this.alterFilters({
        [name]: value
      }));
      _defineProperty(this, "resetFilters", () => new Promise(resolve => {
        var filters = new Filters(this.props.listingType, {
          localities: this.props.filters.localities,
          bounds: this.props.filters.bounds
        });
        this.setState({
          filters
        }, () => resolve(filters));
      }));
      /**
       * Completely replaces the current filters
       */
      _defineProperty(this, "replaceFilters", newFilters => {
        this.setState({
          filters: new Filters(this.props.listingType, newFilters)
        });
      });
      _defineProperty(this, "buildTitles", function (titleFunc) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        return {
          staticTitle: titleFunc(_this.props.filters, ...args),
          liveTitle: titleFunc(_this.state.filters, ...args)
        };
      });
      this.state = {
        // Uncommitted search options, still under edit
        filters: new Filters(props.listingType, props.filters)
      };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(newProps) {
      var filters = new Filters(newProps.listingType, newProps.filters);
      if (!isEqual(this.props.filters.getValues(), filters.getValues())) {
        this.setState({
          filters
        });
      }
    }
    render() {
      var priceRangeProps = _objectSpread(_objectSpread({}, buildPriceRangeProps(this.state.filters, this.props.priceRanges, this.alterNamedFilter('price'))), this.buildTitles(getPriceRangeTitle));
      var propertyTypeProps = _objectSpread(_objectSpread({}, buildPropertyTypeProps(this.state.filters, this.alterNamedFilter('propertyTypes'))), this.buildTitles(function (filters) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        return getPropertyTypeTitle(filters, options.isMobile, ...args);
      }));
      var propertyFeaturesProps = _objectSpread(_objectSpread({}, buildPropertyFeaturesProps(this.state.filters, this.alterFilters)), this.buildTitles(getPropertyFeaturesTitle));
      var moreOptionsProps = _objectSpread(_objectSpread(_objectSpread({}, buildMoreOptionsProps(this.state.filters, this.alterFilters)), this.buildTitles(getMoreOptionsTitle({
        btrEnabled: this.props.toggledFeatures[ToggledFeatureKey.BUILD_TO_RENT]
      }), this.props.listingType)), {}, {
        visibilityPeriod: this.props.visibilityPeriod
      });
      var baseProps = {
        priceRangeProps,
        propertyTypeProps,
        propertyFeaturesProps,
        moreOptionsProps,
        onClearAll: this.onClearFilter,
        onClearMoreOptions: this.onClearMoreOptions,
        onCancel: this.onCancel,
        onSubmitFilter: this.onSubmitFilter,
        registerDropdown: this.registerDropdown,
        onReplaceFilters: this.replaceFilters,
        listingType: this.props.listingType,
        hasFilterChanged: this.hasFilterChanged
      };
      var props = _objectSpread(_objectSpread({}, this.props), baseProps);
      return ___EmotionJSX(FilterComponent, _extends({}, props, {
        filters: this.state.filters
      }));
    }
  }
  FilterWithState.propTypes = {
    listingType: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    onSubmitFilter: PropTypes.func,
    onCancel: PropTypes.func,
    priceRanges: PropTypes.arrayOf(PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
      step: PropTypes.number.isRequired
    })).isRequired,
    visibilityPeriod: PropTypes.string.isRequired,
    toggledFeatures: PropTypes.shape({
      [ToggledFeatureKey.BUILD_TO_RENT]: PropTypes.bool
    })
  };
  FilterWithState.defaultProps = {
    onSubmitFilter: () => {},
    onCancel: () => {},
    toggledFeatures: {}
  };
  return withAllhomesApi('toggledFeatures')(FilterWithState);
};
export default filterStateHandler;